import type { AgeBasis, PurgeInput, PurgeTarget } from '@restaurant/api-contracts';

export type LabelMatch = 'ANY' | 'ALL';

export const MANAGED_RULE_NAME: Record<PurgeTarget, string> = {
  ORDER: 'Order list cleanup',
  RESERVATION: 'Reservation list cleanup',
};

export const SIMPLE_RULE_DEFAULTS = {
  ageBasis: 'CREATED_AT',
  labelMatch: 'ANY',
  scheduleKind: 'DAILY',
  scheduleHour: 3,
} as const;

export const OLDER_THAN_DAY_CHOICES = [0, 1, 30, 90, 180, 365] as const;

export function cleanupInput(
  target: PurgeTarget,
  olderThanDays: number,
  labelIds: string[],
  ageBasis: AgeBasis = SIMPLE_RULE_DEFAULTS.ageBasis,
  labelMatch: LabelMatch = SIMPLE_RULE_DEFAULTS.labelMatch,
): PurgeInput {
  return {
    kind: 'criteria',
    criteria: {
      target,
      olderThanDays,
      ageBasis,
      labelIds,
      labelMatch,
    },
  };
}
